import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../index";
import { GET_SAVED_COLUMNS, SAVE_COLUMNS } from "../Queries/getSavedColumns"

export const fetchSavedColumnsAsync = createAsyncThunk(
    "columnSettings/getSaved",
    async ({ employeeId, tableId }, { rejectWithValue }) => {
        try {
            const { data } = await client.query({
                query: GET_SAVED_COLUMNS,
                variables: { employeeId, tableId },
                fetchPolicy: "no-cache",
            });

            return {
                tableId,
                columns: data.getSavedColumns?.visibleColumns || []
            };
        } catch (err) {
            return rejectWithValue(err.message || "Failed to fetch saved columns");
        }
    }
);



export const saveColumnsAsync = createAsyncThunk(
    "columnSettings/save",
    async ({ employeeId, tableId, visibleColumns }, { rejectWithValue }) => {
        try {
            const { data } = await client.mutate({
                mutation: SAVE_COLUMNS,
                variables: { employeeId, tableId, visibleColumns },
            });

            return {
                tableId,
                columns: data.saveColumns?.visibleColumns || []
            };
        } catch (err) {
            return rejectWithValue(err.message || "Failed to save column settings");
        }
    }
);


const columnSettingsSlice = createSlice({
    name: "columnSettings",
    initialState: {
        saved: {},
        loading: false,
        error: null,
        saveSuccess: false,
    },

    reducers: {
        resetSaveStatus: (state) => {
            state.saveSuccess = false;
        },
    },

    extraReducers: (builder) => {
        builder
            // GET saved columns
            .addCase(fetchSavedColumnsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSavedColumnsAsync.fulfilled, (state, action) => {
                const { tableId, columns } = action.payload;
                state.saved[tableId] = columns;
                state.loading = false;
                state.saveSuccess = true;
            })

            .addCase(fetchSavedColumnsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
                
            })

            // SAVE columns
            .addCase(saveColumnsAsync.pending, (state) => {
                state.loading = true;
                state.saveSuccess = false;
                state.error = null;
            })
            .addCase(saveColumnsAsync.fulfilled, (state, action) => {
                const { tableId, columns } = action.payload;
                state.saved[tableId] = columns; 
            })

            .addCase(saveColumnsAsync.rejected, (state, action) => {
                state.loading = false;
                state.saveSuccess = false;
                state.error = action.payload;
            });
    },
});

export const { resetSaveStatus } = columnSettingsSlice.actions;

export default columnSettingsSlice.reducer;
